export interface MarketReport {
  id: string;
  slug: string;
  title: string;
  summary: string;
  sourceAttribution: string;
  sections: { heading: string; content: string }[];
  keyInsights: string[];
  sources: { title: string; url: string }[];
  publishDate: string;
}

// The historical URL is retained so existing links continue to resolve.
// Content is an explicit methodology guide, not an invented August 2026 dataset.
export const AUGUST_2026_REPORT: MarketReport = {
  id: "adana-gayrimenkul-raporu-agustos-2026",
  slug: "adana-gayrimenkul-raporu-agustos-2026",
  title: "Adana piyasa değerlendirme rehberi",
  summary: "İlan bedeli, yayımlanmış portföy sayısı ve resmî konut fiyat göstergelerini doğru kapsamda okumak için yöntem rehberi.",
  sourceAttribution: "Hazırlayan: Corner Gayrimenkul. Resmî gösterge ve hizmet kaynakları aşağıda bağlantılarıyla verilmiştir.",
  sections: [
    { heading: "İlan bedeli ve gerçekleşmiş satış bedelini ayırın", content: "Bu sitede görünen fiyat, ilgili ilanın talep bedelidir. Bir ilanın yayımlanması, o bedelde işlem gerçekleştiğini göstermez. Aynı ilçedeki farklı mülk türlerini, alanları ve bina özelliklerini tek bir bölge fiyatı olarak yorumlamayın." },
    { heading: "Yayımlanmış portföy sayısının kapsamını okuyun", content: "Bu sayfadaki canlı sayılar yalnızca Corner Gayrimenkul sitesinde şu anda yayımlanmış ilanlardan hesaplanır. Bir ilçedeki toplam gayrimenkul sayısı, tüm piyasanın ilan stoku veya alıcı talebi hakkında sonuç çıkarmaz." },
    { heading: "Resmî endeksin dönemini ve coğrafyasını kontrol edin", content: "TCMB Konut Fiyat Endeksi, konut piyasasındaki fiyat değişimlerinin takibi için göstergeler sunar; zaman serileri EVDS’de yayımlanır. İlgili serinin tarihini, kapsamını ve açıklamalarını birlikte okuyun. Bölgesel veya ulusal bir endeksi tek bir mahalledeki dairenin fiyatı olarak kullanmayın." },
    { heading: "Mülke özel bilgiyi ayrı doğrulayın", content: "Konum ve bazı temel parsel bilgileri için TKGM Parsel Sorgu kullanılabilir. Malik ve tapu kayıtları, yetkili tapu hizmetleri üzerinden incelenir. Güncel imar, altyapı ve kullanım koşullarını ilgili idareden doğrulayın." },
  ],
  keyInsights: ["Fiyat ve özellikleri benzer mülkler arasında karşılaştırın.", "Verinin hangi tarihe, coğrafyaya ve mülk tipine ait olduğunu okuyun.", "Talep bedeli, ilan sayısı ve fiyat endeksinin farklı bilgiler olduğunu dikkate alın."],
  sources: [
    { title: "TCMB — Konut Fiyat Endeksi", url: "https://www.tcmb.gov.tr/wps/wcm/connect/TR/TCMB+TR/Main+Menu/Istatistikler/Reel+Sektor+Istatistikleri/Konut+Fiyat+Endeksi/" },
    { title: "TCMB — Elektronik Veri Dağıtım Sistemi", url: "https://evds3.tcmb.gov.tr/" },
    { title: "TKGM — Parsel sorgulama", url: "https://www.tkgm.gov.tr/e-hizmetler/sik-kullanilanlar/parsel-sorgulama" },
  ],
  publishDate: "2026-10-06",
};
